import makeStore from '../../utils/localstore'

export const LOCALSTORAGE_TOKEN_FIELD = 'auth-token';

export const { get: getToken, set: setToken, reset: resetToken } = makeStore(LOCALSTORAGE_TOKEN_FIELD);
